import React, { useEffect, useRef, useState } from "react"
import { useParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import Overlay from "../../components/Overlay"
import { useAuthUser } from "react-auth-kit"

const CreateOrderPage = () => {
	const auth = useAuthUser()
	const user = auth()
	const navigate = useNavigate()
	const { name, msisdn } = useParams()
	const [error, setError] = useState(null)
	const [profile, setProfile] = useState(null)

	const [formData, setFormData] = useState({
		refillFrequency: "MONTHLY",
		city: "",
		deliveryAddress: "",
		referralCode: "",
		prescriptionFile: null,
	})

	const fileInputRef = useRef(null)

	const [isOpen, setIsOpen] = useState(false)
	const [loading, setLoading] = useState(false)

	const [register] = useState("Fetching Data")
	const [attendanceColor] = useState("#d1d1d1")

	const handleButtonClick = () => {
		fileInputRef.current?.click()
	}

	function bytesToMB(bytes) {
		return (bytes / (1024 * 1024)).toFixed(2) // returns MB as a string with 2 decimals
	}

	const handleChange = (e) => {
		const { name, value, files } = e.target

		setFormData((prev) => ({
			...prev,
			[name]: files ? files[0] : value,
		}))
	}
	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)

		const formPayload = new FormData()
		formPayload.append("refillFrequency", formData.refillFrequency)
		formPayload.append("city", formData.city)
		formPayload.append(
			"deliveryAddress",
			`${formData.deliveryAddress} co (${name} - +${msisdn})`
		)
		formPayload.append("referralCode", profile)
		formPayload.append("file", formData.prescriptionFile)

		try {
			const response = await fetch(
				`https://api.baobabcircle.com/pharmacy/order/prescription-upload`,
				{
					method: "POST",
					headers: {
						Authorization: `Bearer ${user.apikey}`,
						// Authorization: `Bearer zmsBkCwHuLVZIfJ2GA3sYdwZc1bqRvP9fLMqlHA3rPsPiYSwcRjW8mGY9MRKH0Kw`,
					},
					body: formPayload,
				}
			)

			const result = await response.json()
			if (result.error) {
				setError(result.error)
				setLoading(false)
				return
			}
			navigate(`/orders/${result.data.orderNumber}`)
		} catch (error) {
			setError(error.message)
			console.error("Error uploading order:", error)
		} finally {
			setLoading(false)
		}
	}
	useEffect(() => {
		fetch(`${process.env.REACT_APP_BASE_URL}/api/v2/che-tool/profile`, {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				apiKey: user.apikey,
			},
		})
			.then((response) => response.json())
			.then((result) => {
				setProfile(result.referrerCode)
			})
			.catch((error) => {
				console.log(error)
			})
		return
	}, [user.apikey])

	useEffect(() => {
		return function () {
			window.scrollTo(0, 0)
		}
	}, [])

	return (
		<section className="max-w-[1090px] w-full mx-auto px-[19px] sm:grid sm:pb-[80px]">
			<div className="flex justify-between py-[19px]">
				<div className="">
					<div className="text-[20px] font-bold">Orders</div>
					<div
						className="text-[13px] mt-[3px]"
						style={{ color: attendanceColor }}
					>
						{register}
					</div>
				</div>
			</div>
			<div className="bg-white p-[19px] grid gap-[14px] rounded-[2px] sm:mt-[19px] mt-[10px] w-full sm:order-3">
				<div className="flex">
					<div className="text-[17px] font-medium">Create Order</div>
				</div>
				<form
					onSubmit={handleSubmit}
					className="grid sm:flex sm:flex-col md:grid-cols-[1fr_1fr] gap-[16px]"
				>
					<div className="flex  col-span-2 justify-center items-center">
						<div className="w-full text-center border-[1px] border-dashed border-[#f2994a] rounded-[2px] py-[2rem] bg-[#fff7f0]">
							<p className="text-lg font-semibold text-gray-800">
								Upload Prescription
							</p>
							{!formData.prescriptionFile && (
								<p className="text-sm text-gray-500 mt-2">
									Supported formats: JPEG, JPG, PNG, PDF
								</p>
							)}
							{formData.prescriptionFile && (
								<p className="text-sm text-gray-500 mt-2">
									{formData.prescriptionFile.name} -{" "}
									{bytesToMB(formData.prescriptionFile.size)}{" "}
									MB
								</p>
							)}
							<button
								type="button"
								onClick={handleButtonClick}
								className="text-white bg-[#f2994a] rounded-[3px] flex h-[32px] px-[1rem] mx-auto mt-[10px]"
							>
								<span className="m-auto flex justify-center gap-[0.2rem]">
									<span className="text-[12px]">
										Upload File
									</span>
								</span>
							</button>

							<input
								className="mt-4"
								type="file"
								name="prescriptionFile"
								onChange={handleChange}
								ref={fileInputRef}
								style={{ display: "none" }}
								accept=".jpg,.jpeg,.png,.pdf"
							/>
						</div>
					</div>
					<div className="flex flex-col">
						<div className="text-[13px] font-medium] pl-[10px] pb-[5px]">
							Refill Frequency
						</div>
						<select
							name="refillFrequency"
							value={formData.refillFrequency}
							onChange={handleChange}
							required
							className="  text-[#333333] rounded-[3px] h-[32px] my-[2px] ml-[2px] outline-none  px-[10px] text-[14px] shadow-inner-custom"
						>
							<option value="MONTHLY" selected>
								Monthly
							</option>
						</select>
					</div>
					<div className="flex flex-col">
						<div className="text-[13px] font-medium] pl-[10px] pb-[5px]">
							City
						</div>
						<input
							type="text"
							name="city"
							value={formData.city}
							onChange={handleChange}
							placeholder="Enter city"
							required
							className="  text-[#333333] rounded-[3px] h-[32px] my-[2px] ml-[2px] outline-none  px-[10px] text-[14px] shadow-inner-custom"
						/>
					</div>
					<div className="flex flex-col">
						<div className="text-[13px] font-medium] pl-[10px] pb-[5px]">
							Delivery Address
						</div>
						<input
							type="text"
							name="deliveryAddress"
							value={formData.deliveryAddress}
							onChange={handleChange}
							placeholder="Enter delivery address"
							required
							className="  text-[#333333] rounded-[3px] h-[32px] my-[2px] ml-[2px] outline-none  px-[10px] text-[14px] shadow-inner-custom"
						/>
					</div>
					{/* <div className="flex flex-col">
						<div className="text-[13px] font-medium] pl-[10px] pb-[5px]">
							Referral Code
						</div>
						<input
							type="text"
							name="referralCode"
							value={formData.referralCode}
							onChange={handleChange}
							placeholder="Enter referral code"
							className="  text-[#333333] rounded-[3px] h-[32px] my-[2px] ml-[2px] outline-none  px-[10px] text-[14px] shadow-inner-custom"
						/>
					</div> */}
					{error && (
						<div className="text-[12px] text-[#FF7373] text-center leading-[1] col-span-2">
							{error}
						</div>
					)}
					<div className="flex flex-col md:block col-span-2">
						<button
							type="submit"
							disabled={loading}
							className="text-white bg-[#f2994a] sm:w-full  rounded-[3px] flex h-[32px] px-[1rem]"
						>
							<span className="m-auto flex justify-center gap-[0.2rem]">
								<span className="text-[12px]">
									{!loading && <span>Submit Order</span>}
									{loading && <span>Loading...</span>}
								</span>
							</span>
						</button>
					</div>
				</form>
			</div>
			<Overlay
				isOpen={isOpen}
				onClose={() => {
					setIsOpen(false)
				}}
			/>
		</section>
	)
}
export default CreateOrderPage
